import './App.css';

import React from 'react'
import {
 BrowserRouter as Router,
 Routes,
 Route
} from "react-router-dom";

import LangRoute from './components/LangRoute'
import LangRedirect from './components/LangRedirect'
import PathRedirect from './components/PathRedirect'
import RouteTracker from './components/RouteTracker'
import CookieConsent from './components/CookieConsent'

import MainPage from './containers/MainPage'
import SolutionPage from './containers/SolutionPage'
import TechPage from './containers/TechPage'
import OdoPage from './containers/OdoPage'
import GeneralPage from './containers/GeneralPage'
import StoryPage from './containers/StoryPage'
import BlogPage from './containers/BlogPage'
import LaundryBlogPost from './containers/LaundryBlogPost'
import ContactUsPage from './containers/ContactUsPage'
import CoreTechnologyPage from './containers/CoreTechnologyPage'
import CareersPage from './containers/CareersPage'
import JobDetailPage from './containers/JobDetailPage'
import AboutUsPage from './containers/AboutUsPage'
import CollaboratePage from './containers/CollaboratePage'

/**
 * Route map. Every public page lives under a language prefix (zh-tw, en, ja).
 * The canonical list of indexable routes is www/site-routes.json, which also
 * feeds the sitemap generator and the bot prerender step; keep the two in sync.
 * Retired paths redirect (client side here, 301 at the CloudFront edge).
 */
function App() {
  return (
    <div className="App">
      <Router>
        <RouteTracker />
        <main><Routes>
          {/* Home */}
          <Route path="/:lang/" element={<LangRoute component={MainPage} />} />

          {/* Company */}
          <Route path="/:lang/about/about_us" element={<LangRoute component={AboutUsPage} />} />
          <Route path="/:lang/about/colab_flow" element={<LangRoute component={CollaboratePage} />} />
          <Route path="/:lang/about/career" element={<LangRoute component={CareersPage} />} />
          <Route path="/:lang/about/SE-robot" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/HW-robot" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/softwareIntern" element={<LangRoute component={JobDetailPage} />} />
          <Route path="/:lang/about/hardwareIntern" element={<LangRoute component={JobDetailPage} />} />
          {/* news, security_policy and the intern stories render from GeneralPage content */}
          <Route path="/:lang/about/:page" element={<LangRoute component={GeneralPage} />} />

          {/* Products */}
          <Route path="/:lang/solutions" element={<LangRoute component={SolutionPage} />} />
          <Route path="/:lang/tech/odo" element={<LangRoute component={OdoPage} />} />
          <Route path="/:lang/tech/:page" element={<LangRoute component={TechPage} />} />
          <Route path="/:lang/core-technology" element={<LangRoute component={CoreTechnologyPage} />} />

          {/* Stories, news, contact */}
          <Route path="/:lang/stories" element={<LangRoute component={StoryPage} />} />
          <Route path="/:lang/blog" element={<LangRoute component={BlogPage} />} />
          <Route path="/:lang/blog/laundry-gr00t" element={<LangRoute component={LaundryBlogPost} />} />
          <Route path="/:lang/contact" element={<LangRoute component={ContactUsPage} />} />

          {/* Retired paths inside the language prefix (mirrored as 301s in cloudfront-function.js) */}
          <Route path="/:lang/tech/collie" element={<PathRedirect to="/tech/odo" />} />
          <Route path="/:lang/tech/elephant" element={<PathRedirect to="/solutions" />} />
          <Route path="/:lang/tech/spider" element={<PathRedirect to="/solutions" />} />
          <Route path="/:lang/tech/pms100m" element={<PathRedirect to="/solutions" />} />
          <Route path="/:lang/tech/pp100" element={<PathRedirect to="/solutions" />} />
          <Route path="/:lang/tech/ilp100" element={<PathRedirect to="/solutions" />} />
          <Route path="/:lang/home" element={<PathRedirect to="/" />} />
          <Route path="/:lang/why-nexuni" element={<PathRedirect to="/about/about_us" />} />
          <Route path="/:lang/about/intern" element={<PathRedirect to="/about/career" />} />
          <Route path="/:lang/about/environment" element={<PathRedirect to="/about/career" />} />

          {/* Pre-2026 query-string URLs redirect to the language-prefixed paths */}
          <Route path="/MainPage" element={<LangRedirect />} />
          <Route path="/SolutionPage" element={<LangRedirect />} />
          <Route path="/ContactUsPage" element={<LangRedirect />} />
          <Route path="/StoryPage" element={<LangRedirect />} />
          <Route path="/BlogPage" element={<LangRedirect />} />
          <Route path="/GeneralPage" element={<LangRedirect />} />
          <Route path="/TechPage" element={<LangRedirect />} />

          {/* Root — serve default language (zh-tw) directly, no redirect */}
          <Route path="/" element={<LangRoute component={MainPage} />} />

          {/* Catch-all */}
          <Route path="*" element={<LangRedirect />} />
        </Routes></main>
        <CookieConsent />
      </Router>
    </div>
  );
}

export default App;
